import type { CurrentNetworkContext, YammerState } from '../../state/types';

type GetNetworkContext = (state: YammerState) => CurrentNetworkContext;
export const getNetworkContext: GetNetworkContext = (state: YammerState) => state.session.networkContext;
